<template lang="pug">
.payments
    h3.payments__title {{ $t('strings.payments') }}
    h2.payments__amount {{ total | currency }}
    vm-table(:data="invoices")
        template(slot="thead")
            vm-th(:key="index" v-for="(column, index) in columns") {{ column.label }}
        template(slot-scope="{data}")
          vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in payments")
            vm-td(v-if="column.value != 'amount'" data="data[indextr][column]" :key="index" v-for="(column, index) in columns") {{ payments[indextr][column.value] }}
            vm-td(v-if="column.value == 'amount'" data="data[indextr][column]" :key="index" v-for="(column, index) in columns") {{ payments[indextr][column.value] | currency }}

</template>

<script>
export default {
  name: 'DashboardBreakdown',
  props: {
    invoices: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    total: function () {
      return this.invoices.reduce((acc, item) => {
        return acc + parseFloat(item.balance)
      }, 0).toFixed(2)
    },
    payments: function () {
      return this.invoices.reduce((payments, invoice) => {
        return payments.concat(invoice.payments)
      }, [])
    }
  }
}
</script>

<style lang="scss">
.payments {
    &__title {
        font-size: 18px;
        font-weight: 500;
        line-height: 27px;
        letter-spacing: 0em;
        text-align: left;
        color: #929292;
    }

    &__amount {
        font-size: 32px;
        font-weight: 700;
        line-height: 48px;
        letter-spacing: 0em;
        text-align: left;
    }
}
</style>
